export default __webpack_public_path__ + "static/negy-23ef5e9589a198e48dac4287f3e24ce8.jpg";